import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DropdownToggle, UncontrolledDropdown } from 'reactstrap';

import { Icon } from '@hub-mono/ui';
import { deleteDummyData } from '../../api/company';
import { getCompanyId, selectCompanySubdomain } from '../../selectors/company';
import { getUrl } from 'utils/browserUtil';

import { showDeletingDummyDataModal } from '../../actions/modalActions';
import { modalActions } from '@hub-mono/app-modules';

const DeleteDummyDataButton = () => {
    const dispatch = useDispatch();
    const domain = useSelector(selectCompanySubdomain);
    const companyId = useSelector(getCompanyId);
    const onClick = () => {
        dispatch(
            modalActions.showDeleteConfirmationModal({
                onConfirm: async () => {
                    dispatch(showDeletingDummyDataModal());
                    try {
                        await deleteDummyData(companyId);
                    } finally {
                        const url = getUrl(domain);
                        window.location.href = `${url}/main#/startTour?welcome-to-hubplanner-3213444`;
                    }
                },
                title: 'Delete dummy data',
                message: 'This will permanently delete all demo data and cannot be undone.',
                confirmText: 'Delete',
            })
        );
    };

    return (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav>
                <div onClick={onClick} style={{ padding: 2 }}>
                    <Icon name="broom" size={18} color="primary-container" />
                </div>
            </DropdownToggle>
        </UncontrolledDropdown>
    );
};

export default DeleteDummyDataButton;
